import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import { theme } from "styles/mui-config";

export const StyledLink = styled(Link)`
  text-decoration: none;
  width: max-content !important;
`;
///////////// Drawer Link //////////////

const activeDrawerLink = ({ $isActive }) => {
  if ($isActive) {
    return css`
      background-color: #FFF;
      z-index: 10000;
      border-radius: 40px !important;
      border: 0 !important;
      & .MuiButtonBase-root {
          * {
          color: ${theme.palette.primary.main} !important;
        }
      }
      margin-right: 20px;

    `;
  }
};
export const StyledDrawerLink = styled(Link)`
  text-decoration: none;
  display: flex;
  align-items: center;
  width: 100%;
  ${activeDrawerLink}
`;
